import type { ComponentProps } from "react";

import { cn } from "../../lib/cn";
import { ChevronIcon } from "../icons";

export type ActionTone = "warn" | "info" | "alert";

const edgeClassNames: Record<ActionTone, string> = {
	warn: "border-l-warn-mid",
	info: "border-l-info-mid",
	alert: "border-l-alert-mid",
};

const chipClassNames: Record<ActionTone, string> = {
	warn: "bg-warn-soft text-warn",
	info: "bg-info-soft text-info",
	alert: "bg-alert-soft text-alert",
};

export interface ActionPillProps extends ComponentProps<"a"> {
	readonly tone?: ActionTone;
	readonly count: number;
}

/** The left-edge "one thing you can do" row. It is an anchor: route with ActionPillLink from components/links. */
export function ActionPill({ tone = "info", count, className, children, ...props }: ActionPillProps) {
	return (
		<a
			className={cn(
				"flex w-full press cursor-pointer items-center gap-[9px] rounded-[9px] border-l-[3px] bg-surface px-[13px] py-2 text-left font-sans text-body text-ink transition-colors duration-100 hover:bg-surface-2",
				edgeClassNames[tone],
				className,
			)}
			{...props}
		>
			<span
				className={cn(
					"inline-flex h-[21px] min-w-[21px] items-center justify-center rounded-[11px] text-ctl font-semibold tabular-nums",
					chipClassNames[tone],
				)}
			>
				{count}
			</span>
			<span className="flex-1">{children}</span>
			<ChevronIcon
				className="h-[11px] w-[11px] shrink-0 fill-none stroke-ink-4 stroke-[1.8]"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</a>
	);
}
